"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _fontColorMixin = require("../fontColorMixin");
/** @class SpinnerMixin */
/** @method */
var SpinnerMixin = function SpinnerMixin(props) {
  return (0, _styledToken.default)({
    duration: 'Spinner.animation.duration',
    easing: 'Spinner.animation.easing',
    iterations: 'Spinner.animation.iterations'
  }, function (_ref) {
    var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.5 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'linear' : _ref$easing,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? 'infinite' : _ref$iterations;
    return (0, _styledComponents.css)(["@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}animation:spin ", "s ", " ", ";", ""], duration, easing, iterations, (0, _fontColorMixin.fontColorMixin)(props));
  })(props);
};
exports.SpinnerMixin = SpinnerMixin;